import React from "react";
import HeaderImage from "../../Image/Header1.png"
import FooterImage from "../../Image/Footer1.png"
const PrintableContent = React.forwardRef(({ forms, state }, ref) => {
  return (
    <div ref={ref} dir="rtl" style={{ padding: "20px" }}>
      {/* Add a hidden header and footer for printing */}
      <div
  
      >
        <img
          src={HeaderImage}
          alt="Header"
          id="header-image"
          style={{ width: "100%", height: "auto" }}
        />
      
      </div>
    
      {/* Main content */}
      {forms?.map((form, formIndex) => {
        return form.sectionForm.map((section, sectionIndex) => {
          return (
            <div key={formIndex + sectionIndex}>

                {section.title =="ڕاگەیاندن"?"":
                    <div
                    className={section.title.trim() === "خێزان"  ?" p-1 w-3/12 mt-72  m-auto rounded-sm text-white text-center ": ` p-1 w-3/12 mt-4 m-auto rounded-sm text-white text-center `}
                    key={sectionIndex}
                  > 
                  {section.title.trim() === "خێزان" ?<div className="mt-6"></div>:""}
                  <p className="bg-teal-700 p-2 shadow-md rounded-md">{section.title}</p>
                 </div>}
              
              <div className="grid grid-cols-4 gap-3">
                {section.field.map((field, index) => {
                  return (
                    <React.Fragment key={index}>
                      {(field.type === "text" ||
                        field.type === "number" ||
                        field.type === "dropdown") && (
                        <div className="flex flex-col mt-1 text-right ">
                          <div className="w-full  text-sm">
                            <label htmlFor=" text-sm">* {field.label} </label>
                          </div>
                          {field.type === "textarea" ? (
                            <textarea
                              type={field.type}
                              name={field.name}
                              placeholder={field.placeholder}
                              value={state[field.name]}
                              className="p-1.5 input text-right"
                              readOnly
                            ></textarea>
                          ) : field.type === "dropdown" ? (
                            <select
                              className="p-1 w-full input text-right"
                              type={field.type}
                              name={field.name}
                              placeholder={field.placeholder}
                              value={state[field.name]}
                              id=""
                              disabled
                            >
                              <option value="">تکایە زانیاریەکە هەڵبژێرە</option>
                              {field?.drop_down.map((dropdown, index) => {
                                return (
                                  <option value={dropdown.value} key={index}>
                                    {dropdown.value}
                                  </option>
                                );
                              })}
                            </select>
                          ) : (
                            <input
                              type={field.type}
                              name={field.name}
                              placeholder={field.placeholder}
                              value={state[field.name]}
                              className="p-1 input w-full text-right"
                              readOnly
                            />
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>

          

              {/* {section.field.map((field, index) => {
                return (
                  <React.Fragment key={index}>
                    {field.type === "textarea" && (
                      <textarea
                        type={field.type}
                        name={field.name}
                        placeholder={field.placeholder}
                        value={state[field.name]}
                        className="p-1.5 input text-right w-full mt-2"
                        readOnly
                      ></textarea>
                    )}
                  </React.Fragment>
                );
              })} */}
            </div>
          );
        });
      })}
   <div className=" mt-[13rem]">
        <img
          src={FooterImage}
          alt="Footer"
          id="footer-image"
          style={{ width: "100%", height: "auto" }}
        />
      </div>

    </div>
  );
});

export default PrintableContent;